import React, { useState } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {
  BtnGroupStyle,
  ContentStyle,
  DatePickerField,
  DRxSelectStyle,
  greyColor,
  InputSMBoxStyle,
  warnColor,
  IframeStyle,
} from "../../../Theme";
import { YSButton } from "../../../uikit/YSButton";
import * as yup from "yup";
import { ErrorMessage, Form, Formik } from "formik";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import DRxSelect from "../../../uikit/DRxSelect";
import {
  InitializeUserActivity,
  UserActivityGenerateReports,
} from "../../../Apis/AuthApiServices";
import YSSnackBar from "../../../uikit/YSSnackBar";
import useFetch from "../../../CustomHooks/useFetch";
import { REPORT_BASE_URL } from "../../../Apis/Constants";

const initialStateUserActivityReport = {
  fromDate: "",
  toDate: "",
  doctorName: "",
  reportdoctorId: "ALL",
};

export default function UserActivityReport() {
  const [data, setData] = useState(initialStateUserActivityReport);
  const [printActive, setPrintActive] = useState(false);
  const [reportUrl, setReportUrl] = useState("");
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const doctorId: any = localStorage.getItem("doctorId");
  const Params = {
    doctorId: doctorId,
  };
  const { data: docNameDropDown, loading } = useFetch(
    Params,
    InitializeUserActivity,
    []
  );

  if (loading)
    return (
      <>
        <ContentStyle>
          <Typography component="h6" color="primary" variant="h6">
            User Activity Report
          </Typography>

          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"100vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        </ContentStyle>
      </>
    );

  const getUserActivityGenerateReports = async (values: any) => {
    try {
      const doctorId: any = localStorage.getItem("doctorId");
      const params = new URLSearchParams();
      params.append("doctorId", doctorId);
      params.append("fromDate", values?.fromDate);
      params.append("toDate", values?.toDate);
      params.append("reportdoctorId", values?.reportdoctorId);

      const result = await UserActivityGenerateReports(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setReportUrl(result?.data?.response[0]?.reportUrl);
        setPrintActive(true);
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const currentDate = new Date();

  return (
    <>
      <ContentStyle>
        {printActive ? (
          <Grid
            container
            item
            xs={12}
            spacing={0}
            alignItems="top"
            justifyContent="space-between"
            columnSpacing={3}
          >
            <Grid item xs={12}>
              <IframeStyle>
                <iframe src={REPORT_BASE_URL + reportUrl} title="PrintReport" />
              </IframeStyle>
            </Grid>
            <Grid item xs={12}>
              <BtnGroupStyle className="right">
                <YSButton
                  className=""
                  children={"Back"}
                  variant={"outlined"}
                  size={"large"}
                  onClick={() => {
                    setPrintActive(false);
                  }}
                />{" "}
              </BtnGroupStyle>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography component="h6" color="primary" variant="h6">
              User Activity Report
            </Typography>

            <Formik
              initialValues={data}
              validationSchema={yup.object().shape({
                fromDate: yup
                  .date()
                  .nullable()
                  .required("From Date is Required")
                  .typeError("Date of Birth is Required"),
                toDate: yup
                  .date()
                  .nullable()
                  .required("To Date is Required")
                  .typeError("Date of Birth is Required"),
              })}
              onSubmit={(values) => {
                setData(values);
                getUserActivityGenerateReports(values);
              }}
              enableReinitialize
            >
              {({
                handleChange,
                values,
                handleBlur,
                touched,
                errors,
                setFieldValue,
              }) => (
                <Form>
                  <Grid
                    container
                    item
                    xs={12}
                    spacing={0}
                    alignItems="top"
                    justifyContent="center"
                    columnSpacing={3}
                  >
                    <Grid item xs={12} md={8}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="userrole"
                        >
                          Doctor Name
                        </Typography>
                        <Box>
                          <DRxSelectStyle>
                            <DRxSelect
                              name="reportdoctorId"
                              id="doctorNames"
                              data={
                                docNameDropDown ?? [{ label: "", value: "" }]
                              }
                            />
                          </DRxSelectStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="fromdate"
                        >
                          From Date
                          <Typography
                            component="span"
                            color={warnColor}
                            variant="body1"
                          >
                            *
                          </Typography>
                        </Typography>

                        <Box>
                          <DatePickerField>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                inputFormat="MM/dd/yyyy"
                                value={values.fromDate}
                                maxDate={currentDate}
                                onChange={(e) => {
                                  setFieldValue(
                                    "fromDate",
                                    moment(e).format("MM/DD/yyyy")
                                  );
                                }}
                                renderInput={(params) => (
                                  <>
                                    <TextField
                                      {...params}
                                      error={
                                        touched.fromDate &&
                                        Boolean(errors.fromDate)
                                      }
                                    />
                                    <Typography
                                      color="error"
                                      className="error"
                                      variant="body2"
                                      component="div"
                                    >
                                      <ErrorMessage name="fromDate" />
                                    </Typography>
                                  </>
                                )}
                              />
                            </LocalizationProvider>
                          </DatePickerField>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="toDate"
                        >
                          To Date
                          <Typography
                            component="span"
                            color={warnColor}
                            variant="body1"
                          >
                            *
                          </Typography>
                        </Typography>

                        <Box>
                          <DatePickerField>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                inputFormat="MM/dd/yyyy"
                                value={values.toDate}
                                maxDate={currentDate}
                                onChange={(e) => {
                                  setFieldValue(
                                    "toDate",
                                    moment(e).format("MM/DD/yyyy")
                                  );
                                }}
                                renderInput={(params) => (
                                  <>
                                    <TextField
                                      {...params}
                                      error={
                                        touched.toDate && Boolean(errors.toDate)
                                      }
                                    />
                                    <Typography
                                      color="error"
                                      className="error"
                                      variant="body2"
                                      component="div"
                                    >
                                      <ErrorMessage name="toDate" />
                                    </Typography>
                                  </>
                                )}
                              />
                            </LocalizationProvider>
                          </DatePickerField>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>

                    <Grid item xs={12} textAlign={"center"}>
                      {" "}
                      <YSButton
                        style={{ marginTop: 35 }}
                        size="large"
                        className=""
                        color="primary"
                        dataTestId="submitBtn"
                        variant="contained"
                        disabled={false}
                        type="submit"
                        children={"Generate Reports"}
                      />
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </>
        )}
      </ContentStyle>
      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
